//@ts-strict-ignore
import React from 'react';
import Workspace from '../../components/Workspace/Workspace';
import { SalesReceipt } from '../../graphql/entities';
import Formatters from '../../components/grid-addons/formatters';
import { useWorkspace } from '../../graphql/hooks/useWorkspace';
import { Direction } from '../../graphql/schema/p4types';
import { ModalFormatter } from '../../components/grid-addons/formatters/ModalFormatter';

const LazyCustomerForm = React.lazy(() => import('../../views/customer/CustomerForm'));

const SALES_RECEIPT_COLUMN_OVERRIDES = {
  documentNumber: {
    name: 'Number',
    key: 'documentNumber',
    width: 100,
  },
  documentStatus: {
    name: 'Status',
    width: 80,
    formatter: Formatters.DocumentStatusFormatter,
  },
  postingDate: {
    name: 'Posting Date',
    key: 'postingDate',
    formatter: 'date',
    width: 110,
  },
  documentDate: {
    name: 'Date',
    key: 'documentDate',
    formatter: 'date',
    width: 110,
  },
  documentAmount: {
    key: 'documentAmount',
    formatter: Formatters.NumericFormatter,
    options: {
      format: { decimals: 2 },
    },
    width: 150,
  },
  discountAmount: {
    name: 'Discount',
    key: 'discountAmount',
    formatter: Formatters.NumericFormatter,
    options: {
      format: { decimals: 2 },
    },
    width: 150,
  },
  'customer.reference': {
    name: 'Customer',
    formatter: ModalFormatter,
    width: 125,
    options: {
      modalContent: LazyCustomerForm,
      modalProps: { forceReadOnly: true },
      entityId: 'customer.id',
    },
  },
};

const SALES_RECEIPT_FIELD_NAMES = [
  'documentNumber',
  'documentDate',
  'documentStatus',
  'customer.reference',
  'customer.name',
  'documentReference',
  'documentAmount',
  'discountAmount',
];

const { readOnlyStatus, formUrl, type, title, workspace } = SalesReceipt;

const SalesReceiptWorkspace = (props) => {
  const workspaceProps = useWorkspace(props, SalesReceipt, {
    columns: SALES_RECEIPT_FIELD_NAMES,
    columnOverrides: SALES_RECEIPT_COLUMN_OVERRIDES,
    initialSortColumn: 'documentNumber',
    initialSortDirection: Direction.Desc,
  });

  return (
    <Workspace
      entityType={type}
      title={title}
      formUrl={formUrl}
      defaultQuery={workspace}
      readOnlyStatus={readOnlyStatus}
      {...workspaceProps}
      {...props}
      entity={SalesReceipt}
    />
  );
};

export default SalesReceiptWorkspace;
